"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = root;
var _effects = require("redux-saga/effects");
var _sagas = require("../../utils/sagas");
var _reduxSaga = require("redux-saga");
var _selectors = require("../session/selectors");
var _types = require("../app/types");
var _constants = require("../app/constants");
var _oldHttpClient = require("../../apiClient/oldHttpClient");
var _selectors2 = require("../rooms/selectors");
var _selectors3 = require("../network/selectors");
var _token = require("../../utils/token");
var _actions = require("../session/actions");
var _sagas2 = require("../session/sagas");
var _types2 = require("../session/types");
var _types3 = require("../rooms/types");
var _actions2 = require("./actions");
var _uuid = require("../../utils/uuid");
var _constants2 = require("./constants");
var _types4 = require("./types");
var _callbacks = _interopRequireDefault(require("../../callbacks"));
var _config = _interopRequireDefault(require("../../config"));
var _errorHandler = _interopRequireDefault(require("../../utils/errorHandler"));
var _logger = _interopRequireDefault(require("../../utils/logger"));
var _manager = _interopRequireDefault(require("./manager"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var logger = new _logger.default('saga:websocket');
var disconnectTimeout;
var handleWSEvents = emitter => action => {
  return emitter(_objectSpread(_objectSpread({}, action), {}, {
    type: action.code ? "WS_".concat(action.code) : "".concat(action.type)
  }));
};
function startWS() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return function* () {
    try {
      var _Callbacks$get, _Callbacks$get2;
      logger.log('startWS');
      // as soon as we run theWS creation procedure, add a lock to informe the store that we are connecting
      var BackgroundTimerClearTimeout = _callbacks.default.get('backgroundTimerClearTimeout');
      if (disconnectTimeout && BackgroundTimerClearTimeout) {
        BackgroundTimerClearTimeout(disconnectTimeout);
      } else if (disconnectTimeout) {
        disconnectTimeout = 0;
      }
      var reduxPersist = yield (0, _effects.select)(state => state._persist);

      // wait redux persist rehydratation only if redux perist is set
      if ((reduxPersist === null || reduxPersist === void 0 ? void 0 : reduxPersist.rehydrated) === false) {
        yield (0, _effects.take)('persist/REHYDRATE');
      }
      var currentToken = yield (0, _effects.select)(_selectors.userToken);
      if (!currentToken) {
        yield (0, _effects.take)(_types2.UPDATE_TOKEN); // wait for token to be set
      }

      var token = yield (0, _effects.call)(_sagas2.refreshTokenLogic);
      var lastEventAt = yield (0, _effects.select)(state => (0, _selectors.sessionSelector)(state).lastWSEventAt);
      var _user = yield (0, _effects.select)(_selectors.getUserId);
      var appVersion = _callbacks.default.get('getVersion')();
      var buildNumber = (_Callbacks$get = _callbacks.default.get('getBuildNumber')()) !== null && _Callbacks$get !== void 0 ? _Callbacks$get : 0;
      var _client = yield (0, _effects.select)(_selectors._currentClientSelector);
      if (!_client) {
        _client = (0, _uuid.generate)();
        yield (0, _effects.put)((0, _actions.setClient)(_client));
      }
      var clientSource = (_Callbacks$get2 = _callbacks.default.get('getSource')()) !== null && _Callbacks$get2 !== void 0 ? _Callbacks$get2 : 'web';
      if (!_user || !_client || !token) return;
      var wsOptions = _objectSpread(_objectSpread({}, options), {}, {
        queryParameters: _objectSpread({
          _user,
          _client,
          client: clientSource,
          timestamp: Date.now(),
          token,
          lastEventAt,
          appVersion,
          buildNumber
        }, options.queryParameters || {}),
        primusOptions: _objectSpread({
          // manual: true,
          timeout: 20000,
          /**
           * If you are using authentication you should disable the timeout strategy as
           * there is no way of detecting the difference between a failed authorization
           * and a failed connect. If you leave this enabled with authorization every
           * unauthorized access will try to reconnect again.
           */
          /*
              timeout is now managed, in WS_ERROR we have 401 checking, if true, reconnect strategy is removed by logout
          */
          strategy: ['online', 'disconnect', 'timeout'],
          transport: {
            transports: ['websocket']
          },
          reconnect: _config.default.websocket.reconnect || {
            max: 10000,
            // Infinity, // Number: The max delay before we try to reconnect.
            min: 500,
            // Number: The minimum delay before we try reconnect.
            retries: 10 // Number: How many times we should try to reconnect.
          }
        }, options.primusOptions || {})
      });
      var ws = yield (0, _effects.call)(_manager.default.createWebSocket, _constants2.WEBSOCKET_NAME, "".concat(_config.default.websocketHostname, "/primus"), wsOptions);
      var channel = (0, _reduxSaga.eventChannel)(emitter => {
        ws(handleWSEvents(emitter));
        return () => ws.destroy();
      });
      while (true) {
        var action = yield (0, _effects.take)(channel);
        if (action) {
          yield (0, _effects.put)(action);
        }
      }
    } catch (e) {
      logger.error('startWS:catch', e);
    } finally {
      logger.error('startWS:cancelled');
    }
  }();
}
function* handleStartWS(action) {
  try {
    var isWsLaunchable = yield (0, _effects.select)(_selectors3.getIsWsCanLaunchSelector);
    if (!_config.default.websocketHostname || !isWsLaunchable) {
      logger.warn('handleStartWS:skip', _config.default.websocketHostname, {
        isWsLaunchable
      });
      return;
    }

    // call saga and attach it to root, to avoid process cancellation on children
    yield (0, _effects.spawn)(startWS, action);
  } catch (e) {
    logger.error('handleStartWS:catch', e);
  } finally {
    if (yield (0, _effects.cancelled)()) logger.error('handleStartWS:cancelled');
  }
}
var closeWebSocket = () => {
  try {
    // only call on android
    if (_callbacks.default.get('getAppState')() === _constants.APP_STATES.BACKGROUND) {
      var state = _callbacks.default.get('getState')();
      var _ringingRooms = (0, _selectors2.getRingingRoomsSelector)(state);
      var _currentClientRooms = (0, _selectors2.getCurrentByClientRoomsSelector)(state);
      if (_ringingRooms.length || _currentClientRooms.length) {
        // ringing or current room are running, will postpone the action stop
        logger.log('stopWS:closeWebSocket - DISCONNECT_AFTER cancelled');
        _callbacks.default.get('dispatch')((0, _actions2.stopWebsocket)());
      } else {
        logger.log('stopWS:closeWebSocket - DISCONNECT_AFTER done');
        _manager.default.close(_constants2.WEBSOCKET_NAME);
      }
    } else {
      logger.log('stopWS:closeWebSocket:skip - not in Background state');
    }
  } catch (e) {
    logger.error('stopWS:closeWebSocket:catch', e);
  }
};
function* closeWebSocketLogic() {
  try {
    if (_callbacks.default.get('getAppState')() === _constants.APP_STATES.BACKGROUND) {
      var _ringingRooms = (0, _selectors2.getRingingRoomsSelector)(_callbacks.default.get('getState')());
      var _currentClientRooms = (0, _selectors2.getCurrentByClientRoomsSelector)(_callbacks.default.get('getState')());
      var backgroundTimerStart = _callbacks.default.get('backgroundTimerStart', false);
      if (backgroundTimerStart) backgroundTimerStart();
      if (_ringingRooms.length || _currentClientRooms.length) {
        // ringing or current room are running, will postpone the action stop
        logger.log('stopWS:closeWebSocketLogic - DISCONNECT_AFTER cancelled');
        yield (0, _effects.call)(stopWS, {
          type: 'closeWebSocketLogic'
        });
      } else {
        logger.log('stopWS:closeWebSocketLogic - DISCONNECT_AFTER done');
        _manager.default.close(_constants2.WEBSOCKET_NAME);
      }
      var backgroundTimerStop = _callbacks.default.get('backgroundTimerStop', false);
      if (backgroundTimerStop) backgroundTimerStop();
    } else {
      logger.log('stopWS:closeWebSocketLogic:skip - not in Background state');
    }
  } catch (e) {
    logger.error('stopWS:closeWebSocketLogic:catch', e);
  } finally {
    if (yield (0, _effects.cancelled)()) logger.error('stopWS:closeWebSocketLogic:cancelled');
  }
}
function* stopWS(action) {
  try {
    var _action$action;
    var type = (action === null || action === void 0 ? void 0 : action.type) || (action === null || action === void 0 || (_action$action = action.action) === null || _action$action === void 0 ? void 0 : _action$action.type);
    logger.log('stopWS triggered by %s', type);
    var backgroundTimerStart = _callbacks.default.get('backgroundTimerStart', false);
    if (backgroundTimerStart) backgroundTimerStart();
    if (type === _types2.REQUEST_LOGOUT) {
      return _manager.default.close(_constants2.WEBSOCKET_NAME);
    }
    var _currentClientRooms = yield (0, _effects.select)(_selectors2.getCurrentByClientRoomsSelector);
    var {
      disconnectAfter
    } = _config.default.websocket;
    if (_currentClientRooms.length) {
      logger.log('stopWS - Room Call detected', {
        _currentClientRooms
      });
      yield (0, _effects.take)([_types3.ROOM_CURRENT_CLIENT_REMOVE]);
      logger.log('stopWS - call finished');
    } else {
      logger.log('stopWS - No Call', {
        disconnectAfter
      });
    }
    var BackgroundTimerClearTimeout = _callbacks.default.get('backgroundTimerClearTimeout', false);
    if (BackgroundTimerClearTimeout) {
      // only on android, need to use callbacks so the closeWebSocket could not be a generator
      if (disconnectTimeout) BackgroundTimerClearTimeout(disconnectTimeout);
      disconnectTimeout = _callbacks.default.get('backgroundTimerSetTimeout')(closeWebSocket, disconnectAfter);
    } else {
      // case of web and ios
      if (disconnectAfter) yield (0, _effects.delay)(disconnectAfter);
      yield (0, _effects.call)(closeWebSocketLogic);
    }
    var backgroundTimerStop = _callbacks.default.get('backgroundTimerStop', false);
    if (backgroundTimerStop) backgroundTimerStop();
  } catch (e) {
    logger.error('stopWS:catch', e);
  } finally {
    if (yield (0, _effects.cancelled)()) logger.error('stopWS:cancelled');
  }
}
function sendLogic(_ref) {
  var {
    payload
  } = _ref;
  return function* (_ws$_spark, _ws$_primus) {
    var ws = _manager.default.getWs(_constants2.WEBSOCKET_NAME);
    logger.log((ws === null || ws === void 0 ? void 0 : ws._id) || '', (ws === null || ws === void 0 || (_ws$_spark = ws._spark) === null || _ws$_spark === void 0 ? void 0 : _ws$_spark.slice(0, 7)) || '', 'sendLogic', (payload === null || payload === void 0 ? void 0 : payload.code) || '', {
      payload
    });
    var isWSOnline = ws === null || ws === void 0 || (_ws$_primus = ws._primus) === null || _ws$_primus === void 0 ? void 0 : _ws$_primus.online;
    try {
      if (isWSOnline) {
        ws.send(payload);
      } else {
        yield (0, _effects.call)(_errorHandler.default.captureException, new Error('No ws availiable for sending payload'), 'ws:sendLogic');
      }
    } catch (e) {
      logger.log(e);
    }
  }();
}
var $validateToken = token => (0, _oldHttpClient.getAxiosProvider)()({
  method: 'head',
  url: '/auth/check',
  // url: `${config.websocketHostname}/primus?t=${Date.now()}`,
  headers: {
    Authorization: token,
    'Content-Type': 'application/json; charset=utf-8'
  }
});
function* check401(action) {
  var _ws$_primus2, _ws$_primus3;
  var ws = _manager.default.getWs(_constants2.WEBSOCKET_NAME);
  var url = ws === null || ws === void 0 || (_ws$_primus2 = ws._primus) === null || _ws$_primus2 === void 0 || (_ws$_primus2 = _ws$_primus2.url) === null || _ws$_primus2 === void 0 ? void 0 : _ws$_primus2.href;
  var {
    attempt
  } = (ws === null || ws === void 0 || (_ws$_primus3 = ws._primus) === null || _ws$_primus3 === void 0 || (_ws$_primus3 = _ws$_primus3.recovery) === null || _ws$_primus3 === void 0 ? void 0 : _ws$_primus3.attempt) || {};
  try {
    if (url && (!attempt || attempt === 1)) {
      var _ws$_params;
      logger.log('check401', {
        url,
        attempt
      }, action === null || action === void 0 ? void 0 : action.type);

      // don't know if it's due to bad token or connection failed
      // need to know the HTTP status code
      var token = yield (0, _effects.select)(_selectors.userToken);
      var usedToken = ws === null || ws === void 0 || (_ws$_params = ws._params) === null || _ws$_params === void 0 ? void 0 : _ws$_params.queryParameters.token;
      if ((0, _token.isExpired)(usedToken) && (0, _token.isExpired)(token)) {
        logger.log('check401:logout - no token valid');
        yield (0, _effects.put)((0, _actions.logout)());
        return;
      }

      // test request with ws token
      if (!(0, _token.isExpired)(usedToken)) {
        try {
          var result = yield (0, _effects.call)($validateToken, usedToken);
          logger.log('check401:success with ws token', result);
          return result;
        } catch (e) {
          var _e$response;
          logger.error('check401:failed with ws token', e);
          if ((e === null || e === void 0 || (_e$response = e.response) === null || _e$response === void 0 ? void 0 : _e$response.status) !== 401) {
            return; // not a 401, continue
          }
        }
      }

      if (!(0, _token.isExpired)(token)) {
        try {
          var _result = yield (0, _effects.call)($validateToken, token);
          logger.log('check401:success with redux token', _result);
          ws === null || ws === void 0 || ws.setToken(token);
          return _result;
        } catch (e) {
          var _e$response2;
          logger.error('check401:failed with redux token', e);
          // neither redux or ws token is valid, logout
          if ((e === null || e === void 0 || (_e$response2 = e.response) === null || _e$response2 === void 0 ? void 0 : _e$response2.status) === 401) {
            return yield (0, _effects.put)((0, _actions.logout)());
          }
        }
      }
    }
  } catch (e) {
    logger.error('check401:catch', e);
  }
}
function handleWsError() {
  var action = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return function* () {
    var {
      payload: {
        reason
      }
    } = action;
    logger.log('handleWsError:init', reason);
    if (reason === 'Cannot connect to server') {
      yield (0, _effects.call)(check401, action);
    }
  }();
}
function* root() {
  yield (0, _effects.all)([(0, _sagas.takeLatest)([_types.APP_STATE_FOREGROUND, _types2.REQUEST_LOGIN_SUCCESS, _types4.WS_LAUNCH], handleStartWS), (0, _sagas.takeEvery)(_types4.WS_SEND, sendLogic), (0, _sagas.takeLatest)([_types.APP_STATE_BACKGROUND, _types2.REQUEST_LOGOUT, _types4.WS_STOP], stopWS), (0, _sagas.takeLatest)(_types4.WS_ERROR, handleWsError), (0, _sagas.takeLatest)(_types4.WS_CONNECTING, check401)]);
}
module.exports = exports.default;